// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3986cf91","977":"ff89bfc8"}[chunkId] + ".chunk.js";
};